<div class="flex align-items-center">
  <div *ngIf="status.toLowerCase() === 'cold'">
    <i class="fa-regular fa-snowflake text-blue-300 text-lg mr-2"></i>
  </div>
  <div *ngIf="status.toLowerCase() === 'warm'">
    <i class="fa fa-temperature-empty text-orange-400 text-lg mr-2"></i>
  </div>
  <div *ngIf="status.toLowerCase() === 'hot'">
    <i class="fa fa-fire p-error text-lg mr-2"></i>
  </div>
  <span class="text-xs text-600 font-medium">{{status}}</span>
</div>